// extracted by mini-css-extract-plugin
export var dataCell = "_on-2";
export var dataRow = "_on-0";
export var headerRow = "_on-1";